import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import WorkflowName from 'automation-ui-references/customer-data/WorkflowName';
import { CLASSIC } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicEnrollInWorkflowActionDetail = ({
  actionMetadata,
  messageLangPath = 'actionDetail',
  options = {}
}) => {
  const {
    workflowId
  } = actionMetadata;
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.classic-enroll-in-flow.action-detail.content",
    options: {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: CLASSIC,
        id: workflowId
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.classic-enroll-in-flow.action-preview.content",
    options: {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: CLASSIC,
        id: workflowId
      }),
      objectName: options.objectName
    }
  });
};
export default ClassicEnrollInWorkflowActionDetail;